import { withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { IPreviewTooltipCallback, PreviewTooltipCallbackSymbol } from 'feature-click-handler-registrar'
import { EditorNavigationSymbol, IEditorNavigation, INavigationInfo } from 'ds-feature-editor-navigation'
import { LOADING_PHASES, NavigationInfoSymbol, LoggerSymbol, ILogger } from '@wix/thunderbolt-symbols'
import { DynamicPagesResponseHandlerSymbol } from 'feature-dynamic-pages'
import type { DynamicPagesErrorCallbacksAPI } from 'feature-dynamic-pages'
import { IUrlHistoryManager, UrlHistoryManagerSymbol } from 'feature-router'

const viewerManagerNavigationApiFactory = (
	{ getNextNavigationIntent, isDuringNavigationInteraction }: IEditorNavigation,
	{ getCurrentRootNavigationInfo }: INavigationInfo,
	{ registerToDynamicPagesNavigationError }: DynamicPagesErrorCallbacksAPI,
	urlHistoryManager: IUrlHistoryManager,
	logger: ILogger,
	{ setPreviewTooltipCallback }: IPreviewTooltipCallback
): IViewerManagerImplementor<'navigation'> => {
	return {
		navigation: {
			getCurrentUrl: () => {
				const {
					href,
					host,
					hostname,
					port,
					pathname,
					protocol,
					search,
					hash,
					searchParams,
				} = urlHistoryManager.getParsedUrl()

				return {
					full: href,
					host,
					hostname,
					port,
					path: pathname,
					protocol,
					search,
					hash,
					// @ts-expect-error
					query: Object.fromEntries(searchParams),
				}
			},
			getRootNavigationInfo: () => getCurrentRootNavigationInfo(),
			setPreviewTooltipCallback,
			registerToDynamicPagesNavigationError,
			waitForNavigation: () => {
				logger.phaseStarted(LOADING_PHASES.DS_WAIT_FOR_NAVIGATION)

				return getNextNavigationIntent().then(() => {
					logger.phaseEnded(LOADING_PHASES.DS_WAIT_FOR_NAVIGATION)
				})
			},
			// TODO temporary api ported from bolt until DM can figure out if they really need it.
			// https://wix.slack.com/archives/C9N00LLE6/p1638259538015000?thread_ts=1638109477.471600&cid=C9N00LLE6
			isDuringNavigationInteraction,
		},
	}
}
export const ViewerManagerNavigationApi = withDependencies(
	[
		EditorNavigationSymbol,
		NavigationInfoSymbol,
		DynamicPagesResponseHandlerSymbol,
		UrlHistoryManagerSymbol,
		LoggerSymbol,
		PreviewTooltipCallbackSymbol,
	],
	viewerManagerNavigationApiFactory
)
